import React from 'react';
import ConditionBuilder from '../../../../components/common/ConditionBuilder';
import { Condition } from '../../../../types/segments/segments.types';
import TriggerSubScreenLayout from './TriggerSubScreenLayout';

interface SegmentChangeScreenProps {
  conditions: { [key: string]: Condition[] };
  onConditionsChange: (conditions: { [key: string]: Condition[] }) => void;
  onBack: () => void;
  campaignStatus?: 'draft' | 'live' | 'paused' | 'archived';
}

const SegmentChangeScreen: React.FC<SegmentChangeScreenProps> = ({
  conditions,
  onConditionsChange,
  onBack,
  campaignStatus,
}) => (
  <TriggerSubScreenLayout
    onBack={onBack}
    showLiveBanner={campaignStatus === 'live'}
  >
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <ConditionBuilder
        applyMaxHeight={false}
        conditions={conditions}
        onConditionsChange={onConditionsChange}
        dataSourceOptions={{
          Segment: [
            {
              value: 'segment',
              label: 'Segment',
            },
          ],
        }}
      />
    </div>
  </TriggerSubScreenLayout>
);

export default SegmentChangeScreen;
